import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/stats/users/:userId`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const states = {
  get: apiPathFunc(pathBase),
} as const;
